import {ConfigStore} from "~/chat/ts/store/Config";
import IReview from "~/chat/ts/service/reviews/IReview";
import ChatNodeRequest from "~/chat/ts/service/ChatNodeRequest";

export default class ReviewsFetcher {
    private page = 0;
    private onPage = 10;
    private allSites = false;

    setPage(page: number) {
        if (page >= 0) {
            this.page = page;
        }
        return this;
    }

    getOnPage(): number {
        return this.onPage;
    }

    setOnPage(onPage: number) {
        if (onPage > 0 && onPage <= 50) {
            this.onPage = onPage;
        }
        return this;
    }

    setAllSites(value: boolean) {
        this.allSites = value;
        return this;
    }

    async fetch () {
        let from = this.page * this.onPage;
        let body: CometWidget.CometClientLoadRatesBodyOpenApiModel = {
            orgId: ConfigStore.orgId.value,
            siteId: this.allSites ? "all" : ConfigStore.siteId.value,
            from,
            to: from + this.onPage - 1
        }

        let data = await (new ChatNodeRequest("/loadRates"))
            .setBody(body)
            .send();

        try {
            let parsedData: {
                items: IReview[],
                count: number,
                total?: ReviewsTotalInteface
            } = JSON.parse(data);
            let list = parsedData.items.map(review => {
                if (!review.descr || !review.descr.length) {
                    review.descr = null;
                }
                if (!review.comment || !review.comment.length) {
                    review.comment = null;
                } else {
                    review.comment = review.comment.split("<br />").join(" <br />");
                }
                return review;
            });
            return {
                count: parsedData.count,
                list,
                total: parsedData.total
            };
        } catch (e) {
            return {
                count: 0, list: [], total: null
            };
        }
    }
}

export interface ReviewsTotalInteface {
    totalCount: number,
    averageScore: number,
    goodCount: number,
    badCount: number
}